import React from 'react'

import Modal from '@/shared/Modal'
import { useGlobalState } from '@/state'

// Any component can `setLightbox(url)` via useGlobalState('lightbox') to open an image
// in a modal. Escape / backdrop click closes it (headlessui Dialog handles both).
export default function ImageLightbox() {
  const [url, setUrl] = useGlobalState('lightbox')
  return (
    <Modal isOpen={!!url} closeModal={() => setUrl(null)} full>
      <img src={url} alt='' className='max-h-[80vh] w-auto mx-auto rounded-lg' />
    </Modal>
  )
}
